export default __webpack_public_path__ + "static/media/maxine_detail2.4361693f.jpg";